import { useState, useEffect } from 'react';

/**
 * useViewportWidth — reactive window width with sensible defaults for SSR
 * and the first paint. Listens to resize and orientationchange events.
 */
export default function useViewportWidth() {
  const [w, setW] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth : 1920);
  useEffect(() => {
    const onResize = () => setW(window.innerWidth);
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, []);
  return w;
}

/**
 * Convenience: which named breakpoint is currently active.
 * Matches Tailwind defaults: sm 640 · md 768 · lg 1024 · xl 1280 · 2xl 1536.
 */
export function useBreakpoint() {
  const w = useViewportWidth();
  if (w >= 1536) return '2xl';
  if (w >= 1280) return 'xl';
  if (w >= 1024) return 'lg';
  if (w >= 768) return 'md';
  if (w >= 640) return 'sm';
  return 'xs';
}
